"use strict";var inherit = require("raptor-util/inherit");
var domData = require("../components/dom-data");
var keysByDOMNode = domData._n_;
var vElementByDOMNode = domData._K_;
var createFragmentNode = require("./morphdom/fragment")._k_;
var VNode = require("./VNode");

function VFragment(key, ownerComponent, preserve) {
  this.bV_(null /* childCount */, ownerComponent);
  this.bY_ = key;
  this.ad_ = preserve;
}

VFragment.prototype = {
  bX_: 12,
  bo_: function () {
    var fragment = createFragmentNode();
    keysByDOMNode.set(fragment, this.bY_);
    vElementByDOMNode.set(fragment, this);
    return fragment;
  }
};

inherit(VFragment, VNode);

module.exports = VFragment;